import { message } from "antd";
import {
  AppointmentTimeSlotPlanFormCard,
  AppointmentTimeSlotPlanFormValues,
} from "./components/AppointmentTimeSlotPlanForm";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  fetchAppointmentTimeSlotPlanById,
  updateAppointmentTimeSlotPlanById,
} from "../../../../lib/api/resources/appointmentTimeSlotPlans";
import { useNavigate, useParams } from "react-router-dom";
import { nanoid } from "nanoid";

export const AppointmentTimeSlotPlanEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const appointmentTimeSlotPlanQuery = useQuery({
    queryKey: ["appointmentTimeSlotPlan", id],
    queryFn: async () => {
      const appointmentTimeSlot = await fetchAppointmentTimeSlotPlanById(id);
      return {
        ...appointmentTimeSlot,
        servicePartners:
          appointmentTimeSlot?.servicePartners?.map(
            (servicePartner) => servicePartner.id,
          ) ?? [],
        holidayConfig: appointmentTimeSlot?.holidayConfig?.value ?? null,
        company: appointmentTimeSlot?.company?.id ?? null,
        dealership: appointmentTimeSlot?.dealership?.id ?? null,
        dossierType: appointmentTimeSlot?.dossierType?.iri ?? "",
        planItems:
          appointmentTimeSlot?.planItems?.map((item) => ({
            ...item,
            startTime: item.startTime,
            endTime: item.endTime,
            _key: nanoid(),
          })) ?? [],
      };
    },
  });

  const updateAppointmentTimeSlotPlanMutation = useMutation({
    mutationFn: (data: AppointmentTimeSlotPlanFormValues) =>
      updateAppointmentTimeSlotPlanById(id, data),
    onSuccess: () => {
      navigate(`/appointment-time-slots/plans/${id}`);
      message.success("Planning succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de planning",
      ),
  });

  return (
    <AppointmentTimeSlotPlanFormCard
      initialValues={appointmentTimeSlotPlanQuery.data}
      loading={appointmentTimeSlotPlanQuery.isLoading}
      mutation={updateAppointmentTimeSlotPlanMutation}
      title="Planning bewerken"
      buttonText="Bewerken"
    />
  );
};
